import React from "react";
import { questions } from "../../assets/mbti/mbti.json";
import Button from "@material-ui/core/Button";
import Typo from "@material-ui/core/Typography";
import Progress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import "./mbtiStyle.scss";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import WarinigIcon from "@material-ui/icons/WarningRounded";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import http from "../../services/http.module";

const Range = (min, max) => {
  const arr = [];
  for (min; min < max; min++) arr.push(min);
  return arr;
};

export class MBtiTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      previousPoint: 0,
      previousType: "",
      currentPoint: 0,
      currentType: "",
      canGoNext: false,
      selected: 0,
      parentClassName: "q-shown",
      DialogState: true,
    };
  }

  #personality = {
    I: 0,
    E: 0,
    S: 0,
    N: 0,
    T: 0,
    F: 0,
    J: 0,
    P: 0,
  };

  #count = {
    I: 0,
    E: 0,
    S: 0,
    N: 0,
    T: 0,
    F: 0,
    J: 0,
    P: 0,
  };

  #userChoices = [];

  AnswerA_action = () => {
    const point = questions[this.state.step].answerA.point;
    const type = questions[this.state.step].answerA.type.toUpperCase();
    this.setState({
      currentPoint: point,
      currentType: type,
      canGoNext: true,
      selected: 1,
    });
  };

  AnswerB_action = () => {
    const point = questions[this.state.step].answerB.point;
    const type = questions[this.state.step].answerB.type.toUpperCase();
    this.setState({
      currentPoint: point,
      currentType: type,
      canGoNext: true,
      selected: 2,
    });
  };

  NextAction = () => {
    const step = this.state.step + 1;
    this.#personality[this.state.currentType] += this.state.currentPoint;
    const question = questions[this.state.step];
    const title = `
    ${question.id} - ${question.title}
    ${question.answerA.title} ${this.state.selected === 1 ? "✅" : ""}
    ${question.answerB.title} ${this.state.selected === 2 ? "✅" : ""}
    `;
    this.#userChoices.push(title);
    this.#count[this.state.currentType] += 1;
    this.setState(
      {
        canGoNext: false,
        currentType: "",
        currentPoint: 0,
        previousType: this.state.currentType,
        previousPoint: this.state.currentPoint,
        selected: 0,
        parentClassName: "q-hide",
      },
      () => {
        setTimeout(() => {
          this.setState({
            step,
            parentClassName: "q-shown",
          });
        }, 600);
      }
    );
  };

  NextTest = (index) => {
    setTimeout(() => {
      const ch = Math.floor(Math.random() * 2);
      if (parseInt(ch) === 0) this.AnswerA_action();
      else this.AnswerB_action();

      if (index < 85)
        setTimeout(() => {
          this.NextAction();
          this.NextTest(index + 1);
        }, 505);
    }, 505);
  };

  Testing = () => {
    this.NextTest(this.state.step);
  };

  EndAction = () => {
    let personality = "";
    this.setState({
      parentClassName: "q-hide",
    });

    let firstSection = 0;
    let secondSection = 0;
    let thirdSection = 0;
    let forthSection = 0;

    const IE_max = 25;
    const SN_max = 19;
    const TF_max = 24;
    const JP_max = 19;

    // Calculate I / E
    if (this.#personality.I > this.#personality.E) {
      personality += "I";
      firstSection = (this.#count.I * 100) / IE_max;
    } else {
      personality += "E";
      firstSection = (this.#count.E * 100) / IE_max;
    }

    // Calculate S / N
    if (this.#personality.S > this.#personality.N) {
      personality += "S";
      secondSection = (this.#count.S * 100) / SN_max;
    } else {
      personality += "N";
      secondSection = (this.#count.N * 100) / SN_max;
    }

    // Calculate T / F
    if (this.#personality.T > this.#personality.F) {
      personality += "T";
      thirdSection = (this.#count.T * 100) / TF_max;
    } else {
      personality += "F";
      thirdSection = (this.#count.F * 100) / TF_max;
    }

    // Calculate J / P
    if (this.#personality.J > this.#personality.P) {
      personality += "J";
      forthSection = (this.#count.J * 100) / JP_max;
    } else {
      personality += "P";
      forthSection = (this.#count.P * 100) / JP_max;
    }
    this.props.dispatch({
      type: "SET_MBTI_DATA",
      payload: {
        UserInfo: this.state.formData,
        Personality: personality,
        firstSection,
        secondSection,
        thirdSection,
        forthSection,
      },
    });
    http
      .SubmitMbtiTest({
        UserInfo: this.state.formData,
        Personality: personality,
        Answers: this.#userChoices,
        FirstSection: firstSection,
        SecondSection: secondSection,
        ThirdSection: thirdSection,
        ForthSection: forthSection,
      })
      .then((stat) => {
        this.props.history.push("/mbti/result");
      })
      .catch((e) => {
        alert("لطفا دوباره تلاش کنید");
      });
  };

  HandleInputs = (name) => (v) => {
    this.setState({
      [name]: v.target.value,
    });
  };

  DialogClose = (e) => {
    this.SubmitDialogData([
      "UserName",
      "PhoneNumber",
      "BirthdayDay",
      "BirthdayMonth",
      "BirthdayYear",
      "EducationLevel",
      "IdCode",
      "KidName",
    ])(e);
  };

  SubmitDialogData = (validateFields) => (e) => {
    let valid = true;
    const data = {};

    for (const field of validateFields) {
      if (!this.state[field]) {
        valid = false;
        const jsx = (
          <>
            <Typography
              className="text-warning text-right"
              align="center"
              variant="h6"
            >
              <WarinigIcon />
              لطفا تمامی فیلد ها را پر کنید
            </Typography>
          </>
        );
        this.setState({
          errorData: jsx,
        });
        break;
      } else {
        data[field] = this.state[field];
      }
    }

    if (valid) {
      this.setState({
        DialogState: false,
        formData: data,
      });
    }
  };

  render() {
    return (
      <div className={`row mt-5 p-3`}>
        <div className={`col-12 ${this.state.parentClassName}`}>
          <Dialog
            onClose={this.DialogClose}
            open={this.state.DialogState}
            fullWidth
          >
            <DialogTitle>اطلاعات خود را تکمیل کنید</DialogTitle>
            <DialogContent>
              <div className="row">
                <div className="col-12 mt-3">
                  <TextField
                    label="نام و نام خانوادگی"
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onChange={this.HandleInputs("UserName")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <TextField
                    label="کد ملی کودک"
                    fullWidth
                    type="number"
                    variant="outlined"
                    color="primary"
                    onChange={this.HandleInputs("IdCode")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <TextField
                    label="نام کودک"
                    fullWidth
                    type="text"
                    variant="outlined"
                    color="primary"
                    onChange={this.HandleInputs("KidName")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <TextField
                    label="شماره تماس"
                    fullWidth
                    type="number"
                    variant="outlined"
                    color="primary"
                    onChange={this.HandleInputs("PhoneNumber")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <FormControl fullWidth className="col-12">
                    <FormLabel id="edu-level" className="mr-2">
                      {" "}
                      سطح تحصیلات{" "}
                    </FormLabel>
                    <Select
                      name="EducationLevel"
                      variant={"outlined"}
                      color="secondary"
                      labelId="edu-level"
                      onChange={this.HandleInputs("EducationLevel")}
                    >
                      {[
                        "زیر دیپلم",
                        "دیپلم",
                        "فوق دیپلم",
                        "لیسانس",
                        "فوق لیسانس",
                        "دکترا",
                      ].map((item, index) => (
                        <MenuItem value={item} key={`EDU-${index}-${item}`}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="row">
                <div className="col-12 p-2">
                  <div className="row">
                    <FormControl className="col-3 mr-3 ml-1">
                      <FormLabel id="KBD" variant="outlined">
                        {" "}
                        روز تولد{" "}
                      </FormLabel>
                      <Select
                        labelId="KBD"
                        variant="outlined"
                        color="secondary"
                        onChange={this.HandleInputs("BirthdayDay")}
                      >
                        {Range(1, 32).map((item, index) => (
                          <MenuItem value={item} key={index}>
                            {" "}
                            {item}{" "}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl className="col-3 mr-3 ml-1">
                      <FormLabel id="KBD" variant="outlined">
                        {" "}
                        ماه تولد{" "}
                      </FormLabel>
                      <Select
                        labelId="KBD"
                        variant="outlined"
                        color="secondary"
                        onChange={this.HandleInputs("BirthdayMonth")}
                      >
                        {Range(1, 13).map((item, index) => (
                          <MenuItem value={item} key={index}>
                            {" "}
                            {item}{" "}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl className="col-3 mr-3 ml-1">
                      <FormLabel id="KBD" variant="outlined">
                        {" "}
                        سال تولد{" "}
                      </FormLabel>
                      <Select
                        labelId="KBD"
                        variant="outlined"
                        color="secondary"
                        onChange={this.HandleInputs("BirthdayYear")}
                      >
                        {Range(1330, 1401).map((item, index) => (
                          <MenuItem value={item} key={index}>
                            {" "}
                            {item}{" "}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {this.state.errorData === null ? <></> : this.state.errorData}
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={this.DialogClose}
                color="secondary"
                fullWidth
              >
                ثبت و ادامه
              </Button>
            </DialogActions>
          </Dialog>

          <div className="col-12 text-center">
            <div>
              <Typo variant="h5" className="text-center p-3 font-weight-bold">
                {questions[this.state.step].id} -
                {questions[this.state.step].title}
              </Typo>
            </div>
            <div className="row">
              <div className="col-6 p-3 text-center">
                <Button
                  className={"mr-2 font-weight-bold shadow"}
                  variant={this.state.selected === 1 ? "contained" : "outlined"}
                  color="secondary"
                  onClick={this.AnswerA_action}
                >
                  {questions[this.state.step].answerA.title}
                </Button>
              </div>
              <div className="col-6 p-3 text-center">
                <Button
                  className={"mr-2 font-weight-bold shadow"}
                  variant={this.state.selected === 2 ? "contained" : "outlined"}
                  color="secondary"
                  onClick={this.AnswerB_action}
                >
                  {questions[this.state.step].answerB.title}
                </Button>
              </div>
            </div>
          </div>
          <div className="col-12 text-center p-5">
            {this.state.step === questions.length - 1 ? (
              <Button className="mr-2" onClick={this.EndAction}>
                اتمام
              </Button>
            ) : (
              <>
                <Button
                  className="mr-2 shadow-lg"
                  variant={!this.state.canGoNext ? "outlined" : "contained"}
                  color="primary"
                  disabled={!this.state.canGoNext}
                  onClick={this.NextAction}
                >
                  بعدی
                </Button>
                {/* 
                <Button
                  className="mr-2 shadow-lg"
                  variant={"contained"}
                  color="primary"
                  onClick={this.Testing}
                >
                  تست
                </Button> */}
              </>
            )}
          </div>
        </div>

        <div className="col-12 text-center p-5">
          <div className="row p-4">
            <div className="col-2 p-0 pb-5 text-center">
              {this.state.step + 1}
            </div>
            <div className="col-8">
              <Progress
                variant="determinate"
                value={(this.state.step * 100) / questions.length}
              />
            </div>
            <div className="col-2 p-0 pb-5 text-center">{questions.length}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ MBTI: state.MBTI });
export default connect(mapStateToProps)(MBtiTest);
